<template>
  <transition>
    <div v-if="modal" class="proa-modal-outer">
      <div class="proa-modal" @mousedown.self="onBackdropClose">
        <div :class="['proa-modal-content', size, { 'fluid': fluid }]">
          <div class="proa-modal-header">
            <slot v-if="this.$slots.headerTitle" name="headerTitle"></slot>
            <span v-else class="title">{{ title }}</span>
            <div>
              <slot v-if="this.$slots.headerAsset" name="headerAsset"></slot>
              <span v-if="!hideCloseButton" class="asset-button" @click="onClose">
                <img :src="require('@/assets/images/icons/cross.png')"/>
              </span>
            </div>
          </div>
          <div :class="['proa-modal-body', { 'no-default-body-padding': noDefaultBodyPadding }]">
            <slot></slot>
          </div>
          <div v-if="!hideFooter" class="proa-modal-footer">
            <slot v-if="this.$slots.footer" name="footer"></slot>
            <proa-button v-else @click.native="onClose">
              {{ $t('common.close') }}
            </proa-button>
          </div>
        </div>
      </div>
      <div class="proa-modal-backdrop"/>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ProaModal',
  props: {
    modal: {
      type: Boolean,
      default: true
    },
    fluid: {
      type: Boolean,
      default: false
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    noDefaultBodyPadding: {
      type: Boolean,
      default: false
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    },
    size: {
      // 現状はクレカモーダル用の高さ調整
      title: String,
      default: 'md'
    },
    title: String
  },
  methods: {
    onClose: function() {
      this.$emit('close')
    },
    onBackdropClose: function() {
      if (this.noCloseOnBackdrop) return
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.v-enter-active, .v-leave-active {
  transition: opacity .15s linear;
}

.v-enter, .v-leave-to {
  opacity: 0
}

.proa-modal-outer {
  position: absolute;
  z-index: 1050;

  .proa-modal {
    z-index: 2;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-height: 500px) {
      align-items: flex-start;
      overflow: auto;
    }

    .proa-modal-content {
      background-color: white;
      flex-grow: 1;
      margin: 40px 20px;
      border-radius: 6px;
      display: flex;
      flex-direction: column;

      @include mq(md) {
        margin: 40px;
      }

      &.md {
        height: 500px;
        max-width: 600px;
      }

      &.lg {
        height: 500px;
        max-width: 600px;

        @include mq(md) {
          height: 700px;
          max-width: 600px;
        }
      }

      &.xlg {
        height: 850px;
        width: 100%;
        max-width: 800px;

        @include mq(xs) {
          height: 700px;
        }

        @include mq(md) {
          height: 700px;
          max-width: 1000px;
        }
      }

      &.fluid {
        height: calc(100% - 80px);
        max-width: none;
      }

      .proa-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        border-bottom: 1px solid $dark-border-color;
        height: 60px;
        word-break: keep-all;

        .title {
          font-size: 15px;
          font-weight: 600;
          color: $secondary-color;

          @include mq(md) {
            font-size: 18px;
          }
        }

        .asset-button {
          display: inline-block;
          width: 26px;
          height: 26px;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
            padding: 3px;
          }
        }
      }

      .proa-modal-body {
        flex-grow: 1;
        overflow: auto;
        height: 100%;

        &:not(.no-default-body-padding) {
          padding: 24px 20px;

          @include mq(md) {
            padding: 20px;
          }
        }
      }

      .proa-modal-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 20px;
        border-top: 1px solid $dark-border-color;
        height: 80px;

        button {
          padding: 10px 30px;
        }
      }
    }
  }

  .proa-modal-backdrop {
    z-index: 1;
    opacity: 0.7;
    background-color: #000000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
